import { IsNumber, IsOptional, Min, MinLength } from 'class-validator';

export class SearchQuery {
  @MinLength(2)
  public query: string;

  @IsOptional()
  @IsNumber()
  @Min(1)
  public limit?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  public offset?: number;

  constructor(
    query: string,
    limit?: number,
    offset?: number,
  ) {
    this.query = query;
    this.limit = limit;
    this.offset = offset;
  }
}
